import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useImageTextLogic } from './ImageTextLogic';
import BasicImageTextSkin from './skins/BasicImageTextSkin';

/**
 * ImageText 스킨 가능 컴포넌트 정의
 */
export const ImageTextSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.IMAGE_TEXT,
  name: '이미지-텍스트',
  category: 'content',
  icon: '🖼️',
  supportsExternalSkins: true,
  options: [
    {
      key: 'imageUrl',
      type: 'text',
      label: '이미지 URL',
      placeholder: 'https://example.com/image.jpg',
      description: '표시할 이미지의 URL을 입력하세요'
    },
    {
      key: 'imagePosition',
      type: 'select',
      label: '이미지 위치',
      options: [
        { value: 'left', label: '왼쪽' },
        { value: 'right', label: '오른쪽' }
      ],
      default: 'left'
    },
    {
      key: 'imageWidth',
      type: 'text',
      label: '이미지 너비',
      placeholder: '50%',
      description: '이미지 영역의 너비 (%, px 등)'
    },
    {
      key: 'textWidth',
      type: 'text',
      label: '텍스트 너비',
      placeholder: '50%',
      description: '텍스트 영역의 너비 (%, px 등)'
    },
    {
      key: 'gap',
      type: 'text',
      label: '간격',
      placeholder: '20px',
      description: '이미지와 텍스트 사이의 간격'
    },
    {
      key: 'verticalAlign',
      type: 'select',
      label: '수직 정렬',
      options: [
        { value: 'top', label: '위쪽' },
        { value: 'middle', label: '가운데' },
        { value: 'bottom', label: '아래쪽' }
      ],
      default: 'middle'
    },
    {
      key: 'useSecondImage',
      type: 'checkbox',
      label: '두 번째 이미지 사용',
      description: '텍스트 대신 두 번째 이미지를 표시합니다'
    },
    {
      key: 'secondImageUrl',
      type: 'text',
      label: '두 번째 이미지 URL',
      placeholder: 'https://example.com/second-image.jpg',
      description: '두 번째 이미지의 URL (두 번째 이미지 사용 시)'
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicImageTextSkin as any
  },
  useLogic: useImageTextLogic as any,
  defaultProps: {
    content: '<h3>제목을 입력하세요</h3><p>여기에 내용을 입력하세요. <strong>굵게</strong> 또는 <em>기울임꼴</em>로 강조할 수 있습니다.</p>',
    componentProps: {
      imageUrl: 'https://via.placeholder.com/400x300',
      imagePosition: 'left',
      imageWidth: '50%',
      textWidth: '50%',
      gap: '20px',
      verticalAlign: 'middle',
      useSecondImage: false,
      secondImageUrl: 'https://via.placeholder.com/400x300'
    },
    style: {
      width: '100%',
      padding: '20px',
      boxSizing: 'border-box',
    }
  }
};

export default ImageTextSkinnable;